export default __webpack_public_path__ + "static/media/notFound.ca3917de.jpg";